import { render, staticRenderFns } from "./getResults.vue?vue&type=template&id=e1b6cc6c&scoped=true"
import script from "./getResults.vue?vue&type=script&lang=js"
export * from "./getResults.vue?vue&type=script&lang=js"
import style0 from "./getResults.vue?vue&type=style&index=0&id=e1b6cc6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b6cc6c",
  null
  
)

export default component.exports